package uz.ferro.erp.feature.text.ui

import emotion.react.css
import react.FC
import react.dom.html.ReactHTML.li
import react.dom.html.ReactHTML.ul
import uz.ferro.erp.feature.text.model.ListStyle.*
import web.cssom.ListStyleType
import web.cssom.None

val DocListView: FC<DocItemProps> by lazy {
    FC { props ->
        val items = props.item.listItems.orEmpty()
        ul {
            css {
                listStyleType = when (props.item.listStyle) {
                    SQUARE -> "square".unsafeCast<ListStyleType>()
                    DISC -> "disc".unsafeCast<ListStyleType>()
                    CIRCLE -> "circle".unsafeCast<ListStyleType>()
                    DECIMAL -> "decimal".unsafeCast<ListStyleType>()
                    else -> None.none
                }
            }

            items.forEach {
                li {
                    DocContentView {
                        content = it
                    }
                }
            }
        }
    }
}
